import * as React from 'react';
import { SvgIcon, SvgIconBaseProps } from '../components/SvgIcon/SvgIcon';

export function PlaneTakeOffIcon(props: SvgIconBaseProps): React.JSX.Element {
    return (
        <SvgIcon {...props} viewBox="0 0 24 24">
            <path d="M 8.0820312 3.1132812 L 6.2714844 3.6601562 L 10.269531 10.636719 L 5.1757812 11.980469 L 3.3671875 10.460938 L 2 10.869141 L 4.5625 15.242188 L 20.755859 10.978516 A 1.5 1.5 0 0 0 20.761719 10.976562 A 1.5 1.5 0 0 0 22 9.5 A 1.5 1.5 0 0 0 20.5 8 A 1.5 1.5 0 0 0 20.113281 8.0507812 L 20.113281 8.0488281 L 14.882812 9.4257812 L 8.0820312 3.1132812 z M 3 18 L 3 20 L 21 20 L 21 18 L 3 18 z" />
        </SvgIcon>
    );
}
